<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-button-settings-signal
    [isHorizontalForm]="isHorizontalForm()"
    [settings]="settings()"
    (valueChangeEvent)="onSettingsChange($event)"
/>

<web-settings-footer [isSaveDisabled]="saveDisablePredicate" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
